<template>
  <div class="root" style="width: 640px; margin:0 auto; font-size:0.8em;">
    <a href="javascript:window.print()" class="print-button">Print Report</a>
    <p style="font-size:20px;color:black;"><b>Pesanan Penjualan</b></p>
    <div class="judul"> 
      <div class="row" style="padding:0 1em;">
        <div class="master col-3" style="border-radius: 5px;"> No Order : {{ salesdetail.invoiceNo }} </div>
        <div class="master col-3 offset-6" style="border-radius: 5px;"> TGL : {{moment(salesdetail.date).format("DD MMMM YYYY")}} </div>
      </div>
      <br>
      <div class="row">
        <div class="col-9" style="text-align:left;"> Kepada : {{ salesdetail.customerName }} </div>
      </div>
        <hr class="border-top: 1px solid #8c8b8b;">
        <div id="report-table">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th scope="col">Product Name</th>
                <th scope="col">Qty</th>
                <th scope="col">Price</th>
                <th scope="col">Sub Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for=" (list, index) in salesdetail.salesDetail" v-bind:key = "index">
                <td width="200" style="text-align:left;">{{ list.productName }}</td>
                <td width="200">{{numeral(list.qty).format('0,0.00')}}</td>
                <td width="200" style="text-align:right;">{{ 'Rp.' + numeral(list.price).format('0,0.00')}}</td>
                <td width="200" style="text-align:right;">{{ 'Rp.' + numeral(list.qty * list.price).format('0,0.00')}}</td>
              </tr>
            </tbody>
          </table>
          <hr class="border-top: 1px solid #8c8b8b;">
        </div>
      </div>
  <div class="row" style="padding:0 1em;">
    <div class="col-3 offset-6" style="text-align:right;" > Sub Total :  </div>
    <div class="col-3" style="text-align:right;" > {{ 'Rp.' + numeral(salesdetail.total).format('0,0.00')}} </div>
  </div>
  <div class="row" style="padding:0 1em;">
    <div class="col-3 offset-6" style="text-align:right;" > PPN :  </div>
    <div class="col-3" style="text-align:right;" > {{ 'Rp.' + numeral(salesdetail.grandTotal - salesdetail.total).format('0,0.00')}} </div>
  </div>
  <div class="row" style="padding:0 1em;">
    <div class="col-3 offset-6" style="text-align:right;" > Grand Total :  </div>
    <div class="col-3" style="text-align:right;" > {{ 'Rp.' + numeral(salesdetail.grandTotal).format('0,0.00')}} </div>
  </div>
  </div>
</template>

<script>
import api from '../../services/api'
import { sales, salesDetail } from '../../models/sales'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import html2canvas from 'html2canvas'

export default {
  components: {
    AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
  },
  data() {
    return {
      salesdetail: {...sales, salesDetail: []},
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const salesReportApi = api('print/sales-detail')
      this.salesdetail = await salesReportApi.getWithParams(this.$route.query.id)
    }
    console.log(this.salesdetail)
  },
  methods: {
    async exportToPdf() {
      const input = document.getElementById('report-to-print')
      const canvas = await html2canvas(input, {
        width: 1450,
        height: 1000
      })
      const imgData = canvas.toDataURL('image/png')

      const pdf = new jsPDF('l', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const currentTime = Date.now()
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${this.rs.srNumber}.pdf`)
    }
  }
}
</script>